import React, { useState, useEffect } from "react";
import { AddLegalIformation,GetLegalInfromation } from "../../../API/LegalInfo";
import { toast } from "react-toastify";
import NoData from "../../../components/NoData";
import AddLegalInfo from "./AddLegalInfo";
import LegalInfoList from "./LegalInfoList";

const LegalInformation = () => {
  const [addNewInfo, setAddNewInfo] = useState(false);
  const [legalInfoList, setLegalInfoList] = useState([]);
  const [editInfo, setEditInfo] = useState({});
  const fatchUser = async () => {
    try {
      const response = await GetLegalInfromation();
      if (response?.status) {
        setLegalInfoList(response.data);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error during login request:", error); // Handle any other errors
    }
  };

  useEffect(() => {
    if (!addNewInfo) {
      fatchUser();
    }
  }, [addNewInfo,]);

  const handleAddNewInfo = () => {
    setAddNewInfo(!addNewInfo);
    setEditInfo({});
  };

  const handleEditInfo = (data) => {
    setEditInfo(data);
    setAddNewInfo(true);
  };

  return (
    <div className="user_container">
      <div className="event_header management_header">
        <div className="title">Legal Information</div>
        <div className="event_button management_user">
          { legalInfoList?.length  < 2 ?
          <button className="event_btn" onClick={() => handleAddNewInfo()}>
          Add Legal Information
          </button>
        : ''  }
        </div>
      </div>
      {legalInfoList && legalInfoList?.length > 0 ? (
        <div className="users_list">
          <LegalInfoList
            legalInfoList={legalInfoList}
            onEditInfo={handleEditInfo}
          />
        </div>
      ) : (
        <NoData title="There is no  legal information yet" />
      )}
      {addNewInfo && (
        <AddLegalInfo onModalClose={handleAddNewInfo} editInfo={editInfo} />
      )}
    </div>
  );
};
export default LegalInformation;
